// app/javascript/utils/select2_setup.js
// import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/es.js';

export function select2Setup() {
    select2Cleanup();
    select2Init();
}

export function select2Init() {
    // Inicialización limpia
    $('select.select2').each(function() {
        const $el = $(this);
        if ($el.hasClass('select2-hidden-accessible')) return;
        // Asegurar que cada <select> tenga un atributo id único
        if (!this.id) {
            this.id = 'select2-' + Math.random().toString(36).substr(2, 9);
        }
        try {
            $el.select2({
                tokenSeparators: [',', ' '],
                theme: "classic",
                width: 'resolve',
                language: 'es'
            });
        } catch (e) {
            console.error("Error al inicializar Select2 en:", this, e);
        }
    });
}

export function select2Cleanup() {
    // Limpieza activa universal: Atrapa cualquier Select2 (normal o AJAX)
    // buscando directamente la clase que el plugin inyecta al inicializarse.
    $('.select2-hidden-accessible').each(function() {
        const $el = $(this);
        try {
            $el.select2('destroy');
        } catch(e) {
            // Plan B de limpieza manual si 'destroy' falla
            $el.removeClass('select2-hidden-accessible');
            $el.next('.select2-container').remove();
        }
    });
}

export function select2AjaxInit(selector, options = {}) {
    const $el = $(selector);
    
    if ($el.length === 0) return;

    $el.each(function() {
        const $currentEl = $(this);

        // 1. Asegurar ID único (reutilizando tu lógica)
        if (!this.id) {
            this.id = 'select2-ajax-' + Math.random().toString(36).substr(2, 9);
        }

        // 2. PREVENCIÓN DE CONFLICTOS: 
        // Si select2Init ya lo inicializó como estático, lo destruimos primero
        if ($currentEl.hasClass('select2-hidden-accessible')) {
            try {
                $currentEl.select2('destroy');
            } catch(e) {
                console.error("Error destruyendo Select2 previo en:", this, e);
            }
        }

        // 3. Obtener la URL de las opciones o del data-url del HTML
        const url = options.url || $currentEl.data('url');

        // 4. Inicializar con AJAX
        $currentEl.select2({
            placeholder: options.placeholder || 'Escriba para buscar...',
            allowClear: options.allowClear !== false,
            theme: "classic",
            width: 'resolve',
            minimumInputLength: options.minimumInputLength || 2,
            language: 'es',
            ajax: {
                url: url,
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    return { q: params.term };
                },
                processResults: function(data) {
                    return { results: data.results };
                },
                cache: true
            }
        });

        // 5. Mapeo dinámico de eventos (Callbacks)
        // Desvinculamos eventos previos para evitar ejecuciones múltiples por Turbolinks
        $currentEl.off('select2:select').on('select2:select', function(e) {
            if (typeof options.onSelect === 'function') {
                options.onSelect(e.params.data, this);
            }
        });

        $currentEl.off('select2:unselect').on('select2:unselect', function(e) {
            if (typeof options.onUnselect === 'function') {
                options.onUnselect(e, this);
            }
        });
    });
}